import React from 'react'

export const Loader = ({ className }) => {
  return (
    <div
      className={`absolute inset-0 flex items-center justify-center ${className}`}
    >
      <div className="lds-ring">
        <div></div>
        <div></div>
        <div></div>
        <div></div>
      </div>
    </div>
  )
}
